<template>
  <div
    :style="{ backgroundImage: hideScene ? '' : 'url(' + require('@/assets' + workingArchetype.scene) + ')', height: imgHeight, width: 'auto', backgroundSize: backgroundSize, backgroundPositionX: 'center', backgroundPositionY: backgroundPositionY}">
    <v-img
      v-if="!workingArchetype.animation || hideAnimation"
      :height="height"
      :src="require('@/assets' + workingArchetype.img)"
      :width="width"
      contain
      style="margin-top: 0"
    />
    <lottie v-else
            :height="lottieHeight"
            :options="options"
            :width="lottieWidth"
            @animCreated="handleAnimation"
            :style="disableCenteredDisplay ? 'margin: unset !important;' : ''"
            :key="`${workingArchetype.animation}_${height}_${width}`"
    />
  </div>
</template>

<script>
export default {
  name: 'FinArchetypeIllustration',
  components: {Lottie: () => import('vue-lottie')},
  props: {
    archetype: {},
    hideScene: {
      type: Boolean
    },
    height: {
      type: [Number, String],
      default: 180
    },
    width: {
      type: [Number, String],
      default: 285
    },
    animate: {
      type: Boolean
    },
    disableCenteredDisplay: {
      type: Boolean,
      default: false
    },
    hideAnimation: {
      type: Boolean,
      default: false
    },
    backgroundSize: {
      type: String,
      default: 'contain'
    },
    backgroundPositionY: {
      type: String,
      default: 'bottom'
    }
  },
  data() {
    return {
      anim: null,
      workingArchetype: this.archetype,
    }
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    }
  },
  computed: {
    options() {
      return {
        animationData: this.workingArchetype.animation ? require('@/assets' + this.workingArchetype.animation) : '',
        autoplay: this.animate,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet'
        }
      }
    },
    imgHeight() {
      return typeof this.height === 'string' ? this.height : this.height + 'px'
    },
    lottieHeight() {
      return typeof this.height === 'string' ? 0 : this.height
    },
    lottieWidth() {
      return typeof this.width === 'string' ? 0 : this.width
    }
  },
  watch: {
    archetype(val) {
      this.workingArchetype = val
    },
    animate() {
      if (this.anim) {
        if (this.animate) {
          this.anim.play()
        } else {
          this.anim.pause()
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
